export const aciParking = {
    iconName: 'parking',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M16.035 12.6C18.777 12.6 21 10.451 21 7.8 21 5.15 18.777 3 16.035 3c-2.743 0-4.966 2.15-4.966 4.8 0 2.651 2.223 4.8 4.966 4.8z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M14.793 7.8h1.241c.33 0 .645-.126.878-.351a1.18 1.18 0 00.364-.849c0-.318-.131-.623-.364-.848a1.264 1.264 0 00-.878-.352h-1.241v4.8M4.822 13.286l1.448-3.12c.134-.343.373-.638.684-.846.312-.208.681-.32 1.06-.32h.572M3.621 18.44v1.36c0 .318.13.623.364.848.232.226.548.352.877.352.33 0 .645-.127.878-.352a1.18 1.18 0 00.364-.848v-1.2M19.757 18.44v1.36c0 .318-.13.623-.364.848a1.264 1.264 0 01-.877.352c-.33 0-.645-.127-.878-.352a1.18 1.18 0 01-.364-.848v-1.2',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M11.069 13.2H5.483c-.659 0-1.29.253-1.756.704A2.36 2.36 0 003 15.6v1.8c0 .318.13.623.364.848.232.225.548.352.877.352h14.896c.33 0 .645-.127.878-.352a1.18 1.18 0 00.364-.848v-1.8a2.321 2.321 0 00-.331-1.2',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M5.793 16.2a.305.305 0 01-.31-.3c0-.165.138-.3.31-.3M5.793 16.2c.171 0 .31-.134.31-.3 0-.165-.139-.3-.31-.3M17.585 16.2a.305.305 0 01-.31-.3c0-.165.138-.3.31-.3M17.586 16.2c.171 0 .31-.134.31-.3 0-.165-.139-.3-.31-.3',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                },
            },
        ],
    },
};
